module.exports = __webpack_public_path__ + "fonts/effect-wakandan-insight-ce9f21.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/effect-wakandan-insight.svg
// module id = 848
// module chunks = 0